import { Component, Input, ContentChild } from '@angular/core';
import { ListProps, listSideStyles} from '@kite_aerolab/shared/components';
import { ListDescriptionDirective } from './list-description.directive';
import { BadgeComponent } from '../badge/badge.component';
@Component({
  selector: 'kite-list-side',
  template: `
  <div [ngClass]="listSideStyles">
    <ng-content select="[listTitle]"></ng-content>
    <ng-content select="[listDescription]"></ng-content>
    <ng-container *ngIf="!description">
      <ng-content select="kite-badge"></ng-content>
    </ng-container>
  </div>
  `,
})
export class ListSideComponent {
  @ContentChild(ListDescriptionDirective, { static: false }) description: ListDescriptionDirective;
  @ContentChild(BadgeComponent, { static: false }) badge: BadgeComponent;

  /**
   * Tamaño del list: sm o extra small
   */
  @Input() size: ListProps['size'];
  /**
   * CSS del componente
   */
  @Input() css: ListProps['css'];


  public get listSideStyles(): string[] {
    return [listSideStyles().className];
  }

  ngAfterViewInit () {
    if (this.badge) {    
      this.badge.size = 'md'
    }
  }
}
